import { useRouter } from 'next/router'
import { scroller } from 'react-scroll'
import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { NavigationEvents } from '@mc/track-event'
import { trackPurchaseNowCTAClick } from './utils'

interface PurchaseNowCtaProps {
  className?: string
  location: string
}

export const PurchaseNowCta = ({
  className,
  location,
}: PurchaseNowCtaProps) => {
  const { t } = useTranslation('@mc/next')
  const router = useRouter()

  const handleClick = () => {
    router.push(paths.enterpriseHomepage).then(() => {
      scroller.scrollTo('pricing-section', {
        duration: 700,
        smooth: true,
        offset: -70,
      })
    })
  }

  const purchaseNowText = t('forBusiness.pricingSection.masterClass.button')

  const onCTAClicked = () => {
    trackPurchaseNowCTAClick({
      action: purchaseNowText,
      location,
      level: NavigationEvents.LEVELS.PRIMARY,
      pathname: router.pathname,
      query: router.query,
    })()
    handleClick()
  }

  return (
    <Button
      kind='primary'
      size='sm'
      className={className}
      onClick={onCTAClicked}
    >
      {purchaseNowText}
    </Button>
  )
}
